export enum TeamTypeEnum {
  Diamond = 'diamondTeam',
  Platinum = 'platinumTeam',
  AsAbove = 'asAboveTeam',
}
